<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'

const props = defineProps({ stage: { type: String, required: true } })
const { t } = useI18n()

const TONES = {
  new:              'info',
  in_progress:      'warn',
  resolved:         'muted',
  rental_pending:   'warn',
  rental_active:    'ok',
  rental_returned:  'muted',
  rental_cancelled: 'danger',
}

const tone  = computed(() => TONES[props.stage] || 'muted')
const label = computed(() => t(`inbox.pipeline.${props.stage}`))
</script>

<template>
  <UiStatusPill
    :tone="tone"
    :label="label"
  />
</template>
